import {
  Card,
  CardMedia,
  Grid,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Drawer,
} from "@mui/material";
import { useSelector } from "react-redux";
import { ProfileCardSelector, StaticDataSelector } from "../../store/selector";
import { useNavigate } from "react-router-dom";
import Api from "../../store/api";
import { useEffect, useState } from "react";
import defaultImage from '../../default.jpg'

const ProfileCard = ({ user, onProfileClick }: any) => {
  const navigate = useNavigate();
  const RS: any = useSelector(ProfileCardSelector);
  const staticData: any = useSelector(StaticDataSelector);
  const { hasPayment, firstName } = RS?.authUser;
  const [imageSrc, setImageSrc] = useState(defaultImage);
  const LIST_ALIASES: Record<string, string[]> = {
    countries: ["countries", "country"],
    states: ["states", "state"],
    districts: ["districts", "cities", "district", "city"],
    professions: ["professions", "profession"],
    qualifications: ["qualifications", "qualification"],
    economicStatuses: ["economicStatuses", "economicStatus"],
    castes: ["castes", "caste"],
    subCastes: ["subCastes", "subCaste"],
  };

  const getList = (listKey: string) => {
    const keys = LIST_ALIASES[listKey] || [listKey];
    for (const key of keys) {
      const list = staticData?.[key];
      if (Array.isArray(list) && list.length) return list;
    }
    return [];
  };

  const getNameById = (listKey: string, id: any) => {
    if (id === null || id === undefined || id === "") return "-";
    const list = getList(listKey);
    if (!list.length) return id;
    const matched = list.find((item: any) => String(item?.id) === String(id));
    return matched?.name || id;
  };

  useEffect(() => {
    let isMounted = true;
    setImageSrc(defaultImage);

    Api.getProfileImage(user.id)
      .then((img) => {
        if (isMounted) setImageSrc(img || defaultImage);
      })
      .catch(() => {
        if (isMounted) setImageSrc(defaultImage);
      });

    return () => {
      isMounted = false;
    };
  }, [user.id]);

  const rows = [
    { property: "Name", value: `${user.firstName}` },
    { property: "Age", value: `${user.age} Years Old` },
    { property: "Caste", value: getNameById("castes", user.caste) },
    { property: "Sub Caste", value: `${getNameById("subCastes", user.subCaste)}` },
    { property: "Salary", value: user.salary ? `Rs. ${user.salary} per month` : '' },
    { property: "Qualification", value: getNameById("qualifications", user.qualification) },
    { property: "Profession", value: getNameById("professions", user.profession) },
    { property: "District", value: getNameById("districts", user.city) },
    { property: "State", value: getNameById("states", user.state) },
    { property: "Economic Status", value: getNameById("economicStatuses", user.economicStatus) },
  ];

  const handleProfileClick = (user: any) => {
    if (!hasPayment) navigate('/user/make-payment')
    else {
      const selectedUser = { ...user, img: imageSrc };
      Api.setViewed(user.id)
      onProfileClick(selectedUser)
    }
  }

  return (
    <Card
      onClick={() => handleProfileClick(user)}
      sx={{
        cursor: "pointer",
        transition: "transform 0.15s ease, box-shadow 0.15s ease",
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: 4,
        },
      }}
    >
      <Grid container>
        <Grid item xs={12} sm={12} md={12} xl={12}>
          <CardMedia
            width={200}
            height={400}
            component="img"
            src={imageSrc}
            alt={user.name}
          />
        </Grid>
      </Grid>
      <TableContainer>
        <Table size="small" aria-label="a dense table">
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.property}>
                <TableCell>{row.property}</TableCell>
                <TableCell>{row.value}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default ProfileCard;
